module Meevo.Plugins.SaleProgram {
    "use strict";

    /**
     * Main Section of ServiceCategory
     */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Meevo.Model.ISaleProgram> {
        public model: Meevo.Model.ISaleProgram;
        public startDate: Date;
        public endDate: Date;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            securityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, securityKey);

            this.setInitialValues();
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data: Meevo.Model.ISaleProgram) => {
                this.model = data;
            });
        }

        setInitialValues(): void {
        }

        preSave(): void {
        }

        sectionModelRetrieved(): void {
            if (!this.model) return;
        }
    }
}